module.exports = __webpack_public_path__ + "static/media/img86_R.75624daa.jpg";